import { colors } from '@mui/material';

export default {
	root: {
		textAlign: 'left',
		fontSize: 14
	},
	contained: {
		boxShadow: '0 1px 1px 0 rgba(0,0,0,0.14)',
		backgroundColor: colors.grey[100],
		'&:hover': {
			backgroundColor: colors.grey[300]
		}
	}
};
